__turbopack_context__.v({
  "avatar": "FNnFXa_avatar",
  "body": "FNnFXa_body",
  "card": "FNnFXa_card",
  "desc": "FNnFXa_desc",
  "header": "FNnFXa_header",
  "root": "FNnFXa_root",
  "tag": "FNnFXa_tag",
  "tags": "FNnFXa_tags",
  "title": "FNnFXa_title",
});
